import script from "./LawReport.vue?vue&type=script&setup=true&lang=js"
export * from "./LawReport.vue?vue&type=script&setup=true&lang=js"

import "./LawReport.vue?vue&type=style&index=0&id=584400c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-584400c0"]])

export default __exports__